'use strict';

var helper = require('../helper');

module.exports = {

    pushFindStoreFindInteraction (zipCode, sku, when, size) {
        if (sku !== 'no_product') {
            sku = helper.getFormatSku(sku);
        }
        if (!zipCode) {
            return;
        }

        if (size) {
            let skuSplit = size.split('_');
            let skuMoreSize = [];
            if (skuSplit.length > 0) {
                skuSplit.forEach(function (obj) {
                    skuMoreSize.push(sku + '_' + obj);
                });
                sku = skuMoreSize.join('-');
                size = null;
            }
        } else {
            size = null;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '32',
            'eventname': 'store_locator_search',
            'action': 'search',
            'search_term': helper.formatString(zipCode),
            'product_id': size ? sku + '_' + size : sku,
            'type': when
        };

        helper.log('Pushing pushFindStoreFindInteraction for ' + zipCode + '!', true);
        helper.push(pushObject);
    },

    pushFindStoreGeolocationImpression (zipCode, sku, when, size) {
        if (sku !== 'no_product') {
            sku = helper.getFormatSku(sku);
        }
        if (!location) {
            return;
        }

        if (size) {
            let skuSplit = size.split('_');
            let skuMoreSize = [];
            if (skuSplit.length > 0) {
                skuSplit.forEach(function (obj) {
                    skuMoreSize.push(sku + '_' + obj);
                });
                sku = skuMoreSize.join('-');
                size = null;
            }
        } else {
            size = null;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '33',
            'eventname': 'store_locator_search',
            'action': 'geolocalize',
            'search_term': helper.formatString(zipCode),
            'product_id': size ? sku + '_' + size : sku,
            'type': when
        };

        helper.log('Pushing pushFindStoreGeolocationImpression impression for ' + location + '!', true);
        helper.push(pushObject);
    },

    pushFindStoreGeolocationImpressionCheckout (zipCode, sku, when) {
        if (!location) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '33',
            'eventname': 'store_locator_search',
            'action': 'geolocalize',
            'search_term': helper.formatString(zipCode),
            'product_id': sku,
            'type': when
        };

        helper.log('Pushing pushFindStoreGeolocationImpression impression for ' + location + '!', true);
        helper.push(pushObject);
    },

    pushFindStoreClickResultAction (action, storeName, sku, where) {
        if (!action || !storeName || !sku || !where) {
            return;
        }

        if (sku !== 'no_products') {
            sku = helper.getFormatSku(sku);
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '125',
            'eventname': 'store_locator',
            'action': action,
            'store': storeName,
            'product_id': sku,
            'type': where
        };

        helper.log('Pushing store result action for ' + location + '!', true);
        helper.push(pushObject);
    }

};
